// extracted by mini-css-extract-plugin
export default {"documents-total":"KULAJykXJfTmz5l","documents-info":"IEUHlpmAyTR_5B4","documents-value":"_mlO94xTE7WGbUk","amount":"KGMSAXdBHfJTDsY"};